import { render, staticRenderFns } from "./PromoClosed.vue?vue&type=template&id=8e2d84fe&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e2d84fe')) {
      api.createRecord('8e2d84fe', component.options)
    } else {
      api.reload('8e2d84fe', component.options)
    }
    module.hot.accept("./PromoClosed.vue?vue&type=template&id=8e2d84fe&", function () {
      api.rerender('8e2d84fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/view/PromoClosed.vue"
export default component.exports